import $ from 'jquery';
import './index.scss';
import Sloth from '../Sloth';


@Sloth.component({
    defaultOptions : {}
})

export default class Drawer {

    constructor() {
        this.title = undefined;
        this.body = undefined;
    }

    onInit() {
        const dom = this.dom;
        const self = this;
        if($('.Drawer-wrapper', dom).length === 0) $('<div class="Drawer-wrapper"><h1 class="Drawer-title"></h1><div class="Drawer-body"></div></div>').appendTo(dom);
        $('<button class=\'Drawer-close\'></button>').appendTo('.Drawer-wrapper', dom);

        $(dom).on('click', '.Drawer-close', () => {
            self.hide();
        });

        // 点遮罩关闭
        $(dom).on('click', (evt) => {
            if(!$(evt.target).is('.Drawer')) return;
            this.hide();
        });
    }

    show(options) {
        const { title, body } = options || {};
        if (title) this.title = title;
        if (body) this.body = body;

        this.render();
        $(this.dom).show();
    }

    render() {
        $('.Drawer-title', this.dom).css({display: this.title ? "flex": 'none'});
        $('.Drawer-body', this.dom).css({display: this.body ? "block": 'none'});

        $('.Drawer-title', this.dom).text(this.title);
        $('.Drawer-body', this.dom).html(this.body);
    }

    hide() {
        $(this.dom).hide();
        $(".Drawer-body", this.dom).html("");
    }
}



/** WEBPACK FOOTER **
 ** ./components/Drawer/index.js
 **/